import styleInject from '../../../dependencies/style-inject/dist/style-inject.es.js';

var css_248z = ".rf-attachment[data-v-6e52f9c7] {\n  position: relative;\n  display: inline-flex;\n  width: fit-content;\n  margin: 6px;\n}\n.rf-attachment[data-v-6e52f9c7] .rf-attachment__loader[data-v-6e52f9c7] {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(100% - 4px);\n  height: calc(100% - 4px);\n  top: 2px;\n  left: 2px;\n  border-radius: 20px;\n  background: white;\n  z-index: 2;\n}";
styleInject(css_248z);

export { css_248z as default };
